import { useState } from 'react';
import { Row, Col, Card, Space, Typography, Divider, Checkbox, Button, Modal, Alert, Tag, QRCode } from 'antd';
import CopyText from "../../../components/Text/CopyText";

const { Title, Text } = Typography;

const ShareView = ({ portfolioId }) => {
  const allTabs = ['overview', 'tickers', 'details', 'max exposure', 'allocations', 'performance', 'xray', 'share'];
  const [selectedTabs, setSelectedTabs] = useState([
      'overview', 'tickers', 'details', 'max exposure', 'allocations', 'performance', 'xray', 'share'
  ]);
  const [baseURL] = useState(`${window.location.origin}/public/portfolio/${portfolioId}`);
  const [modalVisible, setModalVisible] = useState(false);

  const handleTabChange = (checkedValues) => {
    setSelectedTabs(checkedValues);
  };
  const handleToggleModalVisible = () => {
    setModalVisible(!modalVisible);
  }

  const getFullUrl = ()=>{
    const params = selectedTabs.map((tab) => `${encodeURIComponent(tab.toLowerCase())}`).join(',');
    return `${baseURL}?views=${params}`;
  }



  return (
      <>
    <Row align="middle">
      <Col span={12}>
        <div style={{ margin: 'auto', width: '600px' }}>
          <QRCode value={getFullUrl()} size={300} iconSize={125} />
        </div>
      </Col>
      <Col span={12}>
        <Space direction="vertical" style={{ backdropFilter: 'blur(3px)' }}>
          <Title level={1}>Scan QR Code to Share</Title>
          <Text ellipsis={{rows: 1}} copyable={true} style={{width: '350px', color: 'red', fontSize: '15px', fontWeight: '600'}}>
            {getFullUrl()}
          </Text>
          <Divider />
          <Text style={{ fontSize: '14px', fontWeight: '600' }}>
            Mobile Version Coming Soon! For now we suggesting viewing with a desktop browser.
          </Text>
          <div onClick={()=>setModalVisible(true)}>
            <Button type="primary" onClick={handleToggleModalVisible}>
              Manage Tabs for Link
            </Button>
            <Divider/>
            <Row gutter={[16, 16]}>
              {selectedTabs.map((tab) => (
                  <Col span={6}>
                    <Tag key={tab} color="red-inverse">
                      {tab.toUpperCase()}
                    </Tag>
                  </Col>
            ))}
            </Row>
          </div>
        </Space>
      </Col>
    </Row>
      <Modal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        title="Control Which Tabs to Share"
      >
        <Card
          bordered={false}
        >
          <Alert
            message={'Select the tabs you want to share with others. The selected tabs will be included in the shared link.'}
          />
          <Divider/>
          <Checkbox.Group value={selectedTabs} onChange={handleTabChange}>
            <Row justify={'space-between'} gutter={[16, 16]}>
              {allTabs.map((tab) => (
                  <Col span={12}>
                    <Checkbox key={tab} value={tab}>
                      {tab.toUpperCase()}
                    </Checkbox>
                  </Col>
                  )
              )}
            </Row>
            <Space direction="vertical">
            </Space>
          </Checkbox.Group>
        </Card>
      </Modal>
      </>
  );
};

export default ShareView;